import { getMsalInstance } from "../msalConfig";
import { clearUserInfo } from "./userUtils";

/**
 * Full application logout: stop refresh timers, clear local auth state, MSAL redirect.
 */
export async function performAppLogout({ postLogoutRedirectUri = "/" } = {}) {
  const { tokenRefreshService } = await import("../services/tokenRefreshService");
  tokenRefreshService.stopAutoRefresh();

  clearUserInfo();

  localStorage.removeItem("appToken");
  localStorage.removeItem("appTokenExpiry");
  localStorage.removeItem("databricksToken");
  localStorage.removeItem("databricksTokenExpiry");
  localStorage.removeItem("tokenExpiry");

  try {
    const msalInstance = getMsalInstance();
    await msalInstance.logoutRedirect({ postLogoutRedirectUri });
  } catch {
    window.location.href = postLogoutRedirectUri;
  }
}
